import React, { useEffect, useMemo } from "react";
import { Button, Col, Row } from "react-bootstrap";
import {
  EditableFieldAmount,
  EditableFieldDateYYYYMMDD,
  EditableFieldText,
} from "../../../../utils/EditableField";
import NewTransactionTable from "./NewTransactionTable";
import { datefilterParamsYYYYMMDD } from "../../Analyze/AnalyzeTransactionsTable";
import {
  useChunkData,
  useTransactions,
} from "../../Analyze/AnalyzeTransactionsTable/hooks";
import { useDispatch, useSelector } from "react-redux";
import { ReduxState } from "../../../../redux";
import {
  fetchMfs,
  fetchTls,
  setSelectedFieldNames,
  setSelectedTransactionStatus,
  setTls,
  toggleLoading,
} from "../../../../redux/reducers/TransactionManager";
import { fetchTotals } from "../../../../redux/reducers/Reconciler";
import Switch from "react-switch";
import { createCorrection } from "../../../../docuclipper/api";
import { createAlert } from "../../../../redux/reducers/Alerts";
import { isArray } from "lodash";
import SummaryTableAccountViewHorizontal2 from "./SummaryTableAccountViewHorizontal2";
import { getDocumentName } from "../../Analyze/AnalyzeTransactionsTable/utils";
import ExternalFilter from "src/views/Docuclipper/ExternalFilter";
import { setExternalFiltersColumnDefs, clearExternalFilters } from 'src/redux/reducers/ExternalFilter';

type Props = {};
export const NewTransactionManager: React.FC<Props> = () => {
  const { job } = useSelector((state: ReduxState) => state.JobData);
  const chunkData = useChunkData();
  const dispatch = useDispatch();
  React.useEffect(() => {
    if (job && !["InProgress", "Finishing", "Canceled"].includes(job.status)) {
      dispatch(fetchTls(true));
      dispatch(fetchMfs());
      dispatch(fetchTotals());
      dispatch(setSelectedFieldNames(undefined));
      dispatch(setSelectedFieldNames(undefined));
      dispatch(setSelectedTransactionStatus(undefined));
    }
  }, [job]);

  const transactions = useTransactions(false);

  const PageNumberCellRenderer = (props) => {
    const values = props.data;

    return <span>{parseInt(values.pageNumber.toString(), 10) + 1}</span>;
  };


  const SwitchCellRenderer = (props) => {
    const values = props.data;
    const {
      documentId,
      fieldName,
      rowNumber,
    } = values;

    return (
      <Switch
        checked={props.data.included}
        // onChange={(e) => null}
        onChange={(e) => {
          if (job) {
            dispatch(toggleLoading());
            createCorrection(
              job.id.toString(),
              documentId,
              fieldName,
              rowNumber,
              -1,
              null,
              e,
              false,
              false
            )
              .then(({ transactions }) => {
                dispatch(toggleLoading());
                dispatch(setTls({ transactions, resetPages: false }));
                dispatch(fetchMfs());

                dispatch(fetchTotals());

                // dispatch(setSelectedAccount(row.values.account));
                // dispatch(setSelectedChunk(row.values.chunk));

                dispatch(
                  createAlert({
                    message: "Included transactions updated successfully",
                    timeout: 0,
                    type: "success",
                  })
                );
              })
              .catch(() => {
                dispatch(toggleLoading());
                dispatch(
                  createAlert({
                    message: "Error updating included transactions",
                    timeout: 0,
                    type: "error",
                  })
                );
              });
          }
        }}
        onColor="#86d3ff"
        onHandleColor="#2693e6"
        handleDiameter={15}
        uncheckedIcon={false}
        checkedIcon={false}
        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
        height={10}
        width={30}
        className="react-switch"
        id="material-switch"
      />
    );
  };

  const EditableQboField = (props) => {
    const { field, fieldType, value } = props;

    const createCorrectionHelper = (
      newText,
      toggleSign,
      divideBy100,
      multilineIndex
    ) => {
      const values = props.data;
      const {
        documentId,
        fieldName,
        rowNumber,
        columnMapping,
        included,
      } = values;

      if (!job) {
        return;
      }
      dispatch(toggleLoading());
      createCorrection(
        job.id as any,
        documentId,
        fieldName,
        rowNumber,
        columnMapping[field],
        newText,
        included,
        toggleSign,
        divideBy100,
        multilineIndex
      )
        .then(({ transactions }) => {
          dispatch(toggleLoading());
          dispatch(setTls({ transactions, resetPages: false }));

          dispatch(fetchTotals());
          dispatch(fetchMfs());
          // dispatch(setSelectedAccount(row.values.account));
          // dispatch(setSelectedChunk(row.values.chunk));

          // dispatch(fetchJobDocuments());
          // dispatch(fetchTls());
          dispatch(
            createAlert({
              message: "Transaction fixed",
              timeout: 0,
              type: "success",
            })
          );
        })
        .catch(() => {
          dispatch(toggleLoading());
          dispatch(
            createAlert({
              message: "Error fixing transaction",
              timeout: 0,
              type: "error",
            })
          );
        });
    };
    if (fieldType === "date") {
      return (
        <EditableFieldDateYYYYMMDD
          onSave={(newValue) =>
            createCorrectionHelper(newValue, false, false, null)
          }
          value={value}
        />
      );
    } else if (fieldType === "number") {
      if (["amount", "balance", "debit", "credit"].includes(field)) {
        return (
          <Row className="align-items-center justify-content-between">
            <Col>
              <EditableFieldAmount
                onSave={(newValue) =>
                  createCorrectionHelper(newValue, false, false, null)
                }
                value={value}
              />
            </Col>
            <Col className="px-0">
              <Button
                className="p-0"
                variant="light"
                size="sm"
                onClick={() => createCorrectionHelper("", true, false, null)}
              >
                +/-
              </Button>
              <Button
                className="p-0 ml-2"
                variant="light"
                size="sm"
                onClick={() => createCorrectionHelper("", false, true, null)}
              >
                .00
              </Button>
            </Col>
          </Row>
        );
      } else {
        return (
          <EditableFieldAmount
            onSave={(newValue) =>
              createCorrectionHelper(newValue, false, false, null)
            }
            value={value}
          />
        );
      }
    } else {
      // text
      if (isArray(value)) {
        return value.map((line, i) => (
          <>
            <EditableFieldText
              key={i}
              onSave={(newValue) =>
                createCorrectionHelper(newValue, false, false, i)
              }
              value={line}
            />
            <br />
          </>
        ));
      } else {
        return (
          <EditableFieldText
            onSave={(newValue) =>
              createCorrectionHelper(newValue, false, false, null)
            }
            value={value}
          />
        );
      }
    }
  };

  const columnDefs = React.useMemo(
    () => [
      {
        field: "documentName",
        headerName: "Document",
        filter: "agTextColumnFilter",
        filterParams: datefilterParamsYYYYMMDD,
        sortable: true,
        flex: 1,
        minWidth: 150,
      },
      {
        field: "pageNumber",
        headerName: "PN",
        filter: "agNumberColumnFilter",
        //filterParams: datefilterParamsYYYYMMDD,
        cellRenderer: PageNumberCellRenderer,
        sortable: true,
        flex: 0.4,
        minWidth: 75,
      },
      {
        field: "included",
        // filter: "agDateColumnFilter",
        // filterParams: datefilterParamsYYYYMMDD,
        // sortable: true,
        flex: 1,
        minWidth: 100,
        cellRenderer: SwitchCellRenderer,
      },
      {
        field: "account",
        filter: "agTextColumnFilter",
        filterParams: datefilterParamsYYYYMMDD,
        sortable: true,
        flex: 0.8,
        minWidth: 150,
      },
      {
        field: "period",
        filter: "agTextColumnFilter",
        // filterParams: datefilterParamsYYYYMMDD,
        sortable: true,
        flex: 1.2,
        minWidth: 220,
        // cellRenderer: PeriodCellRenderer,
      },
      {
        field: "date",
        filter: "agDateColumnFilter",
        filterParams: datefilterParamsYYYYMMDD,
        sortable: true,
        flex: 1,
        minWidth: 150,
        cellRenderer: EditableQboField,
        cellRendererParams: {
          field: "date", //date
          fieldType: "date",
        },
      },
      {
        field: "date2",
        filter: "agDateColumnFilter",
        filterParams: datefilterParamsYYYYMMDD,
        sortable: true,
        flex: 1,
        minWidth: 150,
        cellRenderer: EditableQboField,
        cellRendererParams: {
          field: "date2", //date
          fieldType: "date",
        },
      },
      {
        field: "description",
        filter: "agTextColumnFilter",
        flex: 3,
        filterParams: {
          // pass in additional parameters to the Text Filter
        },
        minWidth: 400,
        cellRenderer: EditableQboField,
        cellRendererParams: {
          field: "name", //description
          fieldType: "text",
        },
      },
      {
        field: "amount",
        filter: "agNumberColumnFilter",
        sortable: true,
        flex: 1.2,
        filterParams: {
          // pass in additional parameters to the Number Filter
        },
        minWidth: 250,
        cellRenderer: EditableQboField,
        cellRendererParams: {
          field: "amount", //description
          fieldType: "number",
        },
      },
      {
        field: "balance",
        filter: "agNumberColumnFilter",
        // sortable: true,
        flex: 1.2,
        filterParams: {
          // pass in additional parameters to the Number Filter
        },
        minWidth: 250,
        cellRenderer: EditableQboField,
        cellRendererParams: {
          field: "balance", //description
          fieldType: "number",
        },
      },
      {
        field: "checkNumber",
        filter: "agTextColumnFilter",
        // sortable: true,
        flex: 1,
        filterParams: {
          // pass in additional parameters to the Number Filter
        },
        minWidth: 150,
        cellRenderer: EditableQboField,
        cellRendererParams: {
          field: "checkNumber", //description
          fieldType: "text",
        },
      },
    ],
    [chunkData.length]
  );

  const defaultColDef = useMemo(() => {
    return {
      resizable: true,
    };
  }, []);

  const {
    selectedDocumentId,
    tls,
    selectedChunk,
    accountChunkLabels,
    selectedAccount,
  } = useSelector((state: ReduxState) => state.TransactionManager);
  const { documents } = tls;

  const gridApi = React.useRef<any>(null);

  const externalFilterColumns = useMemo(() => [
    {
      field: 'description',
      label: 'Description',
      filter: true,
      filterType: 'text',
      defaultFilterType: 'contains'
    },
    {
      field: 'amount',
      label: 'Amount',
      filter: true,
      filterType: 'number',
      defaultFilterType: 'equals'
    },
    {
      field: 'date',
      label: 'Date',
      filter: true,
      filterType: 'date',
      defaultFilterType: 'equals'
    },
    {
      field: 'date2',
      label: 'Date 2',
      filter: true,
      filterType: 'date',
      defaultFilterType: 'equals'
    },
    {
      field: 'balance',
      label: 'Balance',
      filter: true,
      filterType: 'number',
      defaultFilterType: 'equals'
    },
    {
      field: 'checkNumber',
      label: 'Check Number',
      filter: true,
      filterType: 'text',
      defaultFilterType: 'equals'
    },
  ], []);

  useEffect(() => {
    if (!gridApi || !gridApi.current) return;

    const filterModel = {} as any;
    if (selectedDocumentId) {
      filterModel.documentName = {
        type: "equals",
        filter: getDocumentName(documents, selectedDocumentId),
      };
    }

    if (selectedAccount) {
      filterModel.account = {
        type: "equals",
        filter: selectedAccount,
      };
    }

    if (selectedChunk) {
      filterModel.period = {
        type: "equals",
        filter: accountChunkLabels[selectedChunk || ""],
      };
    }

    (gridApi.current as any).setFilterModel(filterModel);
  }, [selectedDocumentId, selectedAccount, selectedChunk, accountChunkLabels]);

  const paginationPageSizeSelector = useMemo(() => {
    return [20, 50, 100];
  }, []);

  useEffect(() => {
    dispatch(clearExternalFilters());
    dispatch(setExternalFiltersColumnDefs({ externalFilterColumnDefs: columnDefs }));
  }, [])

  return (
    <div>
      <Row>
        <Col md="12">
          <div className="new-account-summary p-4">
            <SummaryTableAccountViewHorizontal2 />
          </div>
        </Col>
      </Row>
      <Row className="">
        <Col md="12">
          <div className="new-transactions px-4">
            <Row>
              <Col md="12">
                Filter by
                <ExternalFilter
                  columnDefs={externalFilterColumns}
                  gridApi={gridApi.current}
                />
              </Col>
            </Row>
            <NewTransactionTable
              onSetApi={(api) => (gridApi.current = api)}
              columnDefs={columnDefs}
              defaultColDef={defaultColDef}
              rowData={transactions}
              pagination={true}
              // paginationPageSize={25}
              paginationAutoPageSize={true}
              paginationPageSizeSelector={paginationPageSizeSelector} //only available in later versions
            />
          </div>
        </Col>
      </Row>
    </div>
  );
};
export default NewTransactionManager;
